// extracted by mini-css-extract-plugin
module.exports = {"disc":"e__T","accent":"e_0T","empty":"e_1T","s32":"e_2T","s36":"e_3T","s44":"e_4T","s56":"e_5T","s72":"e_6T"};